import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWizard } from '../../context/WizardContext';
import WizardProgress from '../../components/WizardProgress';
import '../MappingWizard.css';

const Step1Project: React.FC = () => {
  const navigate = useNavigate();
  const { state, saveDraft } = useWizard();

  const [name, setName] = useState(state.mappingName);
  const [description, setDescription] = useState(state.mappingDescription);
  const [saving, setSaving] = useState(false);
  const [savingDraft, setSavingDraft] = useState(false);

  const doSave = async () => {
    return saveDraft(1, { mappingName: name, mappingDescription: description });
  };

  const handleNext = async () => {
    if (!name.trim()) {
      alert('Bitte gib einen Projekt-Namen ein');
      return;
    }
    setSaving(true);
    try {
      await doSave();
      navigate('/wizard/template');
    } catch (err: any) {
      alert(`Fehler beim Speichern: ${err.response?.data?.error || err.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveDraft = async () => {
    if (!name.trim()) {
      alert('Bitte gib einen Projekt-Namen ein');
      return;
    }
    setSavingDraft(true);
    try {
      await doSave();
      alert('Entwurf gespeichert!');
    } catch (err: any) {
      alert(`Fehler beim Speichern: ${err.response?.data?.error || err.message}`);
    } finally {
      setSavingDraft(false);
    }
  };

  return (
    <>
      <WizardProgress currentStep={1} totalSteps={5} />
      <div className="wizard-step">
        <h2>Neues Projekt erstellen</h2>
        <p className="step-description">
          Gib deinem Projekt einen Namen und eine optionale Beschreibung.
        </p>

        <div className="form-group">
          <label htmlFor="name">
            Projekt-Name <span className="required">*</span>
          </label>
          <input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="z.B. Anwesenheitslisten 2025"
            autoFocus
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Beschreibung (optional)</label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Was macht dieses Mapping?"
            rows={4}
          />
        </div>

        <div className="wizard-actions">
          <button
            onClick={() => navigate('/')}
            className="btn-secondary"
          >
            Abbrechen
          </button>
          <button
            onClick={handleSaveDraft}
            className="btn-secondary"
            disabled={!name.trim() || savingDraft || saving}
            style={{ marginLeft: 'auto' }}
          >
            {savingDraft ? 'Speichere...' : 'Entwurf speichern'}
          </button>
          <button
            onClick={handleNext}
            className="btn-primary"
            disabled={!name.trim() || saving || savingDraft}
          >
            {saving ? 'Speichere...' : 'Weiter →'}
          </button>
        </div>
      </div>
    </>
  );
};

export default Step1Project;
